import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import EditSubServiceModal from "./EditSubServiceModal";
import {
  useCreateSubServiceDataMutation,
  useDeleteSubServiceTypeInfoMutation,
  useGetAllServiceDataQuery,
  useGetAllSubServiceDataQuery,
  useGetServiceDataQuery,
} from "../../../Services/vehicle/Vehicle";
import { toast } from "react-toastify";
import useThemeColors from "../ThemeColors";
import DeleteModal from "../DeleteModal";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { stat } from "fs";

interface IPROPS {
  setLiftingName: any;
}
const ITEMS_PER_PAGE = 20;

const SubServiceType: React.FC<IPROPS> = ({ setLiftingName }) => {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [storedData, setStoredData] = useState();
  const [subServiceTableData, setSubServiceTableData] = useState([]);
  const [serviceCategory, setServiceCategory] = useState([]);
  const [service, setService] = useState("");
  const [subService, setSubService] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalCount] = useState(0);
  const [tableLoader, setTableLoader] = useState(false);
  const [uploadButonClicked, setUploadButtonClicked] = useState(false);
  const [image, setImage] = useState<any>("");

  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);

  const { data: serviceCategoryData } = useGetServiceDataQuery({});
  const [createServiceTrigger] = useCreateSubServiceDataMutation();
  const {
    data: subServiceData,
    status,
    refetch,
    isLoading,
  } = useGetAllSubServiceDataQuery({
    page: currentPage,
    page_size: ITEMS_PER_PAGE,
  });
  const [deleteTrigger] = useDeleteSubServiceTypeInfoMutation();

  useEffect(() => {
    if (status === "pending") {
      setTableLoader(true);
    } else {
      setTableLoader(false);
    }
  }, [status]);

  const name = "Service Information";

  useEffect(() => {
    setLiftingName(name);
  }, [setLiftingName]);

  useEffect(() => {
    if (subServiceData) {
      setSubServiceTableData(subServiceData?.results);
      setTotalCount(subServiceData?.count || 0);
    }
  }, [subServiceData]);

  useEffect(() => {
    if (serviceCategoryData) {
      setServiceCategory(serviceCategoryData);
    }
  }, [serviceCategoryData]);

  const createSubCategoryDataHandler = async () => {
    const formData = new FormData();
    formData.append("service_type_id", service);
    formData.append("name", subService);

    if (image) {
      formData.append("image", image); // attach image file
    }

    try {
      const response = await createServiceTrigger(formData);

      if (response?.data) {
        toast.success("Data added successfully");
        setService("");
        setSubService("");
        refetch();
        setImage("");
      } else if (response?.error) {
        // Handle API error response
        const apiError: any = response.error;

        if (apiError?.data?.non_field_errors?.length) {
          toast.error(apiError.data.non_field_errors[0]); // show unique constraint error
        } else if (typeof apiError?.data === "string") {
          toast.error(apiError.data);
        }
      }
    } catch (error: any) {
      toast.error("An unexpected error occurred");
      console.error("Error:", error);
    }
  };

  const editHandler = (vehicle) => {
    setOpenEditModal(true);
    setStoredData(vehicle);
  };

  const closeModal = () => {
    setOpenEditModal(false);
    setOpenDeleteModal(false);
  };

  const deleteHandler = (vehicle) => {
    setStoredData(vehicle);
    setOpenDeleteModal(true);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const isSaveDisabled = !service || subService.trim() === "";

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // Ideally trigger a data fetch here if paginated server-side
    }
  };
  const imageHandler = (e) => {
    setUploadButtonClicked(true);
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };
  return (
    <div className="vehicle-info-cont">
      <div className="workshops-container">
        <div className="vehicle-info-middle">
          <div className="vehicle-info-middle-heading">Add Sub Service</div>
          <div
            className="vehicle-info"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div className="vehicle-class" style={{ width: "50%" }}>
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    fontFamily: "Karbon-medium",
                    fontSize: "16px",
                  }}
                >
                  Service
                </span>
                <select
                  className="form-control"
                  onChange={(e) => setService(e.target.value)}
                  style={{ borderRadius: "20px", background: "#FCFCFC" }}
                  value={service}
                >
                  <option style={{ fontFamily: "Karbon-medium" }}>
                    Select Service
                  </option>
                  {serviceCategory?.map((brand, index) => (
                    <option value={brand?.id}>{brand?.name}</option>
                  ))}
                </select>
                {/* <span>
                      <input
                      className="form-control"
                          type="text"
                          onChange={(e) => setBrandName(e.target.value)}
                          value={brandName}
                      />
                  </span> */}
              </div>
              <div className="vehicle-info" style={{ width: "50%" }}>
                <div className="vehicle-class">
                  <span
                    className="required"
                    style={{
                      paddingLeft: "10px",
                      fontFamily: "Karbon-medium",
                      fontSize: "16px",
                    }}
                  >
                    Sub Service Category
                  </span>
                  <span>
                    <input
                      style={{
                        borderRadius: "20px",
                        background: "#FCFCFC",
                        fontFamily: "Karbon-medium",
                        fontSize: "16px",
                      }}
                      placeholder="Add Sub Service Category"
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        );
                        setSubService(value);
                      }}
                      value={subService}
                    />
                  </span>
                </div>
              </div>
            </div>
            {/* <div>
            <p>
              <label htmlFor="upload-logo"
                style={{
                  background: `${selectedButtonBackgoundColors}`,
                  color: `${selectedButtonColors}`,
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "20px",
                  fontSize: "15px",
                  cursor: "pointer",

                }}
              >
                Upload Logo
              </label>
              {uploadButonClicked ?

                <div style={{ border: "1px solid black", borderStyle: "dotted", height: "200px", width: "200px" }}>
                  {image &&


                    <img src={URL.createObjectURL(image)} alt="preview" width={200} height={200} />
                  }
                </div>
                : ""
              }

              <input
                type="file"
                id="upload-logo"
                style={{ display: "none" }}
                onChange={imageHandler}
                accept=".jpg,.jpeg,.png,.webp"
              />
            </p>


            <span style={{
              fontSize: "12px",
              color: "#666",
              fontFamily: "karbon-semi"
            }}>
              Accepted formats: JPG, PNG, WEBP
            </span>



          </div> */}
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                disabled={isSaveDisabled}
                onClick={createSubCategoryDataHandler}
                style={{
                  background: isSaveDisabled
                    ? "#F7D3C5"
                    : `${selectedButtonBackgoundColors}`,
                  color: `${selectedButtonColors}`,
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "20px",
                  fontSize: "15px",
                  cursor: isSaveDisabled ? "not-allowed" : "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {tableLoader ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="vehicle-info-bottom mt-10">
              <div className="workshops-container">
                <div className="vehicle-info-bottom-heading">
                  Sub Service Types
                </div>
                <table className="vehicle-info-bottom-table">
                  <thead className="thead">
                    <tr
                      className="tr"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      }}
                    >
                      <td>Sr.No.</td>
                      <td>Service Type</td>
                      <td style={{ textAlign: "center" }}>Sub Service Type</td>
                      <td style={{ textAlign: "end", padding: "0 10px" }}>
                        Action
                      </td>
                      {/* <td>Model</td>
                      <td>Fuel type</td> */}
                    </tr>
                  </thead>
                  <tbody className="table-body">
                    {subServiceTableData?.map((vehicle, index) => (
                      <tr
                        className="table-body-tr"
                        style={{
                          background: index % 2 !== 0 ? "#FFF1EC" : "white",
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr 1fr",
                        }}
                      >
                        <td>
                          {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                        </td>
                        <td>{vehicle?.service_type?.name}</td>

                        <td style={{ textAlign: "center" }}>{vehicle?.name}</td>
                        <td
                          style={{
                            // display: "flex",
                            // gap: "10px",
                            // alignItems: "center",
                            // justifyContent: "center",
                            textAlign: "end",
                          }}
                        >
                          <span
                            style={{ marginRight: "10px" }}
                            onClick={() => editHandler(vehicle)}
                          >
                            <i
                              className="bi bi-pencil"
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                              }}
                            ></i>
                          </span>
                          {/* <span onClick={() => deleteHandler(vehicle)}>
                            <i
                              className="bi bi-trash3"
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                              }}
                            ></i>
                          </span> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        <div className="pagination-footer mb-10">
          <div className="pagination-info">
            Showing {startIndex + 1} - {endIndex} of {totalItems}
          </div>

          <div className="pagination-controls">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-btn"
            >
              Prev
            </button>

            {/* Always show exactly 5 page numbers, centered around current page */}
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              // Calculate the first page to show (ensuring we always show 5 if possible)
              let firstPage = Math.max(
                1,
                Math.min(
                  currentPage - 2, // Try to center current page
                  totalPages - 4 // But don't go past total pages - 4
                )
              );

              const pageNum = firstPage + i;

              return (
                <button
                  key={pageNum}
                  onClick={() => handlePageChange(pageNum)}
                  className={`pagination-btn ${
                    pageNum === currentPage ? "active" : ""
                  }`}
                  style={{
                    display: pageNum > totalPages ? "none" : "inline-block",
                    margin: "0 2px",
                    minWidth: "32px",
                    textAlign: "center",
                  }}
                >
                  {pageNum}
                </button>
              );
            })}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <Modal
        open={openEditModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <EditSubServiceModal
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
            />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openDeleteModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <DeleteModal
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
              trigger={deleteTrigger}
              setTableData={setSubServiceTableData}
              fieldsData={subServiceTableData}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default SubServiceType;
